const _excluded = ["_id"];var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useMemo } from 'react';

import { useLoaderData, useRevalidator, useBlocker } from 'react-router-dom';


import { useSetAtom } from 'jotai';

import { Translate } from "../../../../I18N";
import { isEqual } from 'lodash';
import * as SettingsAPI from "../../../api/settings";
import { ConfirmNavigationModal } from "../../../Components/Forms";


import { notificationAtom } from "../../../atoms";
import { settingsAtom } from "../../../atoms/settingsAtom";
import { Button, Table, Sidepanel } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import uniqueID from "../../../../../shared/uniqueID";
import { MenuForm } from "./components/MenuForm";

import { columns } from "./components/TableComponents";

const menuConfigloader =
(headers) =>
async () =>
SettingsAPI.getLinks(headers);

const MenuConfig = () => {
  const links = useLoaderData();
  const [isSidepanelOpen, setIsSidepanelOpen] = useState(false);
  const setNotifications = useSetAtom(notificationAtom);
  const revalidator = useRevalidator();
  const [selectedLinks, setSelectedLinks] = useState([]);
  const [formValues, setFormValues] = useState(
    {}
  );
  const [linkChanges, setLinkChanges] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const setSettings = useSetAtom(settingsAtom);

  useEffect(() => {
    const linksWIthid = links === null || links === void 0 ? void 0 : links.map((link) => {
      const _id = link._id || `tmp_${uniqueID()}`;
      if (link.sublinks) {
        const sublinks = link.sublinks.map((sublink) => _objectSpread(_objectSpread({}, sublink), {}, { _id: `tmp_${uniqueID()}` }));
        return _objectSpread(_objectSpread({}, link), {}, { sublinks, _id });
      }

      return _objectSpread(_objectSpread({}, link), {}, { _id });
    });
    setLinkChanges(linksWIthid);
  }, [links]);

  const sanitizeIds = (_link) => {var _link$_id;
    const link = _objectSpread({}, _link);
    if ((_link$_id = link._id) !== null && _link$_id !== void 0 && _link$_id.startsWith('tmp_')) {
      delete link._id;
    }
    if (link.sublinks) {
      link.sublinks = link.sublinks.map((sublink) => {
        const { _id } = sublink,rest = _objectWithoutProperties(sublink, _excluded);
        return rest;
      });
    }
    return link;
  };

  const blocker = useBlocker(
    !isEqual(
      links,
      linkChanges.map((l) => sanitizeIds(l))
    )
  );

  useMemo(() => {
    if (blocker.state === 'blocked') {
      setShowModal(true);
    }
  }, [blocker, setShowModal]);

  const edit = (row) => {
    const parent = row.getParentRow();

    const link = row.original;
    setFormValues(_objectSpread(_objectSpread({}, link), {}, { groupId: parent === null || parent === void 0 ? void 0 : parent.original._id }));
    setIsSidepanelOpen(true);
  };

  const addLink = () => {
    setFormValues({ _id: `tmp_${uniqueID()}`, title: '', type: 'link', url: '' });
    setIsSidepanelOpen(true);
  };

  const addGroup = () => {
    setFormValues({ _id: `tmp_${uniqueID()}`, title: '', type: 'group', sublinks: [] });
    setIsSidepanelOpen(true);
  };

  const save = async () => {
    const settings = await SettingsAPI.saveLinks(linkChanges.map(sanitizeIds));
    setSettings(settings);
    revalidator.revalidate();
    setNotifications({
      type: 'success',
      text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Updated")
    });
  };

  const deleteSelected = async () => {
    let newLinks = linkChanges.filter(
      (link) => !selectedLinks.find((selected) => selected.original._id === link._id)
    );

    newLinks = newLinks.map((link) => {
      if (link.sublinks) {
        link.sublinks = link.sublinks.filter(
          (sublink) => !selectedLinks.find((selected) => selected.original._id === sublink._id)
        );
      }
      return link;
    });

    setLinkChanges(newLinks);
  };

  const formSubmit = async (values) => {
    setLinkChanges(values);
    setIsSidepanelOpen(false);
  };

  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-account" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Menu" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      enableSelection: true,
      draggableRows: true,
      columns: columns({ edit }),
      data: linkChanges,
      onChange: (data) => {
        setLinkChanges(data);
      },
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Menu"),
      subRowsKey: "sublinks",
      onSelection: setSelectedLinks }
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: selectedLinks.length ? 'bg-primary-50' : '' }, void 0,
    selectedLinks.length > 0 && /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: deleteSelected,
      color: "error",
      "data-testid": "menu-delete-link" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), " ", selectedLinks.length, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "of"), ' ',
    links === null || links === void 0 ? void 0 : links.reduce(
      (acc, link) => {var _link$sublinks;return acc + (link.type === 'group' ? (((_link$sublinks = link.sublinks) === null || _link$sublinks === void 0 ? void 0 : _link$sublinks.length) || 1) + 1 : 1);},
      0
    )
    ),

    selectedLinks.length === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { type: "button", onClick: addLink, "data-testid": "menu-add-link" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add link")
    ), /*#__PURE__*/
    _jsx(Button, { type: "button", onClick: addGroup, "data-testid": "menu-add-group" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add group")
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: save,
      color: "success",
      disabled: links === linkChanges,
      "data-testid": "menu-save" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(Sidepanel, {
      title: /*#__PURE__*/
      _jsx(Translate, { className: "uppercase" }, void 0,
      `${(formValues === null || formValues === void 0 ? void 0 : formValues.title) === '' ? 'New' : 'Edit'} ${
      (formValues === null || formValues === void 0 ? void 0 : formValues.type) === 'group' ? 'Group' : 'Link'
      }`
      ),

      isOpen: isSidepanelOpen,
      closeSidepanelFunction: () => setIsSidepanelOpen(false),
      size: "medium",
      withOverlay: true }, void 0, /*#__PURE__*/

    _jsx(MenuForm, {
      submit: formSubmit,
      closePanel: () => setIsSidepanelOpen(false),
      link: formValues,
      links: linkChanges }
    )
    ),
    showModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, { setShowModal: setShowModal, onConfirm: blocker.proceed })

    ));

};

export { MenuConfig, menuConfigloader };